import { useTranslation } from "react-i18next"
import { CARRIER_NAME_CUBBO } from "../constants/shippingMethods"
import { derivePackageBadgeStatus } from "../utils/packageStatus"
import { statusBadgeClass } from "../utils/statusColors"

const PackageIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5} aria-hidden="true">
        <path strokeLinecap="round" strokeLinejoin="round" d="m20.25 7.5-.625 10.632a2.25 2.25 0 0 1-2.247 2.118H6.622a2.25 2.25 0 0 1-2.247-2.118L3.75 7.5m8.25 3v6.75m0 0-3-3m3 3 3-3M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125Z" />
    </svg>
)
const ExternalLinkIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} aria-hidden="true">
        <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
    </svg>
)

export const PackageCard = ({ pkg, index, shippingMethodName, onViewTracking }) => {
    const { i18n } = useTranslation()
    const badgeStatus = derivePackageBadgeStatus(pkg)
    const isCubbo = pkg.carrier_name === CARRIER_NAME_CUBBO

    return (
        <div className="border border-gray-200 rounded-lg p-4">
            <div className="flex items-start justify-between">
                <div className="flex items-center gap-2">
                    <PackageIcon />
                    <span className="text-sm font-semibold text-gray-900">
                        {i18n.t('multiPackage.package_label', { number: index + 1 })}
                    </span>
                </div>
                <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${statusBadgeClass(badgeStatus)}`}>
                    {i18n.t(`multiPackage.label_status.${badgeStatus}`, { defaultValue: '' })}
                </span>
            </div>

            <div className="mt-3 space-y-1.5">
                <div className="flex items-center justify-between text-sm">
                    <span className="text-gray-500">{i18n.t('showOrder.shipping_method_label')}</span>
                    <span className="text-gray-900 font-medium">
                        {isCubbo ? `Cubbo ${shippingMethodName || ''}`.trim() : pkg.carrier_name}
                    </span>
                </div>
                {pkg.shipping_number && (
                    <div className="flex items-center justify-between text-sm">
                        <span className="text-gray-500">{i18n.t('orderDetails.shipping_number')}</span>
                        <span className="text-gray-900 font-mono text-xs">{pkg.shipping_number}</span>
                    </div>
                )}
            </div>

            <div className="mt-3 flex items-center justify-between">
                <button
                    type="button"
                    onClick={() => onViewTracking?.(index)}
                    className="text-sm font-medium text-blue-500 hover:text-blue-400"
                >
                    {i18n.t('multiPackage.view_package_tracking')}
                </button>
                {pkg.tracking_url && !isCubbo && (
                    <a
                        href={pkg.tracking_url}
                        target="_blank"
                        rel="noreferrer"
                        className="inline-flex items-center gap-1.5 text-sm text-blue-500 hover:text-blue-400"
                    >
                        {i18n.t('showOrder.view_tracking', { carrier_name: pkg.carrier_name })}
                        <ExternalLinkIcon />
                    </a>
                )}
            </div>
        </div>
    )
}
